export const DEFAULT_COURSE_PREVIEW_IMAGE =
  '/images/course-catalog-default.png';

export const USER_SAMPLE_CSV_URL =
  'https://assets.goethena.com/m/28c9f9602cdb6f35/original/sample-csv.csv';
